module.exports = __webpack_public_path__ + "img/transfer_mode1.871c9d5d.png";